import { render, staticRenderFns } from "./DocumentazioneView.vue?vue&type=template&id=1f6f1903&scoped=true"
import script from "./DocumentazioneView.vue?vue&type=script&lang=js"
export * from "./DocumentazioneView.vue?vue&type=script&lang=js"
import style0 from "./DocumentazioneView.vue?vue&type=style&index=0&id=1f6f1903&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6f1903",
  null
  
)

export default component.exports